
import { DxDataGridComponent } from 'devextreme-angular';
import { SelectionData, SelectionElement, SelectionOutput, SettingsService } from 'src/app/pages/settings/settings.service';
import { SelectionSet, Selection } from './../../settings.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DropdownValue } from 'src/app/widgets/dropdown/dropdown.component';

import DxDataGrid from 'devextreme/ui/data_grid';

@Component({
    selector: 'app-selection-set-renderer',
    templateUrl: './selection-set-renderer.component.html',
    styleUrls: ['./selection-set-renderer.component.scss'],
    standalone: false
})
export class SelectionSetRendererComponent implements OnInit {

	/**
	 * Contains all selections that user can choose for this selection set.
	 */
	private _selectionElements: DropdownValue[] = [];
	public get selectionElements(): DropdownValue[] {
		return this._selectionElements;
	}
	public set selectionElements(value: DropdownValue[]) {
		this._selectionElements = value;

		this._selectionElements.sort((a, b) => a.text.localeCompare(b.text));
	}

	/**
	 * Contains generated selection that were manually added and have no list.
	 * Used only when `this.selectionElements` data is missing.
	 */
	public displayOnlySelectionElements: DropdownValue[] = [];

	public aggregateFunctionTypes: DropdownValue[] = [
		new DropdownValue(null, "None"),
		new DropdownValue(0, "AVG"),
		new DropdownValue(1, "COUNT"),
		new DropdownValue(2, "MAX"),
		new DropdownValue(3, "MIN"),
		new DropdownValue(4, "SUM"),
		new DropdownValue(5, "VAR"),
		new DropdownValue(6, "VARP"),
	];

	public selectionModes: DropdownValue[] = [
		new DropdownValue("multiple", "Multiple"),
		new DropdownValue("single", "Single"),
	];

	public data: SelectionData = new SelectionData();

	public selections: Selection[] = [];

	@ViewChild("selectionsDataGrid")
	public selectionsDataGrid: DxDataGridComponent;

	@Output() public selectionSetChange: EventEmitter<SelectionSet> = new EventEmitter<SelectionSet>();
	private _selectionSet: SelectionSet;
	public get selectionSet(): SelectionSet {
		return this._selectionSet;
	}
	@Input()
	public set selectionSet(value: SelectionSet) {
		this._selectionSet = value;

		this.selectionSetChange.emit(this._selectionSet);
	}

	public allowReordering: boolean = true;

	private prepareSelections() {
		this.selections = this.data.selections.filter((selection) => !selection.isDeleted).map((selection) => Object.assign(new Selection(), selection));

		this.selections.forEach((selection) => {
			if (!selection.caption) {
				selection.caption = selection.selectionName;
			}
		});
	}

	public initialize(): void {
		this._settingsService.getSelections(
			this.selectionSet.selectionSetId,
			{
				name: "selection-set-renderer -> initialize",
				showLoadingIndicator: true,
				responseLoggingEnabled: false
			}
		).subscribe(
			(response) => {
				this.data.selections = response.selections ? response.selections : [];

				//? This for loops is needed because `this.data.selections` is missing `isDeleted` property which is causing bugs if it's not there.
				for (let a = 0; a < this.data.selections.length; a++) {
					this.data.selections[a] = Object.assign(new Selection(), this.data.selections[a]);
				}

				this.data.elements = response.elements ? response.elements : [];

				this.selectionElements = this.data.elements.map(
					(field) => {
						const dropdownText = field.caption ? `${field.listElement} [${field.caption}]` : field.listElement;

						return new DropdownValue(field, dropdownText);
					}
				);

				if (this.selectionElements.length === 0) {
					this.displayOnlySelectionElements = [];

					for (let a = 0; a < this.data.selections.length; a++) {
						const selection = this.data.selections[a];

						const dropdownText = selection.caption ? `${selection.selectionName} [${selection.caption}]` : selection.selectionName;

						selection.listElementId = a;

						this.displayOnlySelectionElements.push(
							new DropdownValue(selection, dropdownText)
						);
					}

				
				}

				this.prepareSelections();
			}
		);
	}

	/**
	 * Used to override the behaviour of `setCellValue` in `dxi-column`.
	 * When changing "Column Name" - sets "Caption" column.
	 */
	public setSelectionColumnNameValue(rowData: any, value: any): void {
		const $this = <any>this;

		const selectionElement: SelectionElement = <SelectionElement>($this.lookup.dataSource.find((element) => element.value.listElementId === value)?.value);

		if (selectionElement) {
			rowData.caption = selectionElement.caption;
		}

		$this.defaultSetCellValue(rowData, value);
	}

	public reset() {
		this.selectionSet = null;
		this.selectionElements = [];
		this.data.selections = [];
		this.data.elements = [];
	}

	public onReorder(evt: any): void {
		

	

		
		let data = evt.component.option('dataSource');
		let dataIndex = evt.component.option('dataSource');

		let visibleRows = evt.component.getVisibleRows(),
			toIndex = data.indexOf(visibleRows[evt.toIndex].data),
			fromIndex = data.indexOf(evt.itemData);

		data.splice(fromIndex, 1);
		data.splice(toIndex, 0, evt.itemData);

		

		for (let index = 0; index < data.length; index++) {
			data[index].orderBy = index + 1;
			data[index].orderId = index + 1;
			let selectionId = data[index].selectionId;
			let indexcurrent = dataIndex.findIndex(x => x.selectionId == selectionId);
			evt.component.cellValue(indexcurrent, 'orderId', index + 1);
			evt.component.cellValue(indexcurrent, 'orderBy', index + 1);
			evt.component.cellValue(indexcurrent, '№', index + 1);
		}


		

	}

	public onRowInserted(evt: any): void {
		

		const selection: Selection = <Selection>evt.data;

		const selectionElement: SelectionElement = this.data.elements.find((element) => element.listElementId === selection.listElementId);

		selection.selectionName = selectionElement.listElement;
		selection.searchType = 1;
		selection.isMandatory = false;
		selection.isDeleted = false;
		selection.caption = selectionElement.caption;
		selection.orderBy = this.data.selections.length;

		this.data.selections.push(selection);

		this.prepareSelections();
	}

	public onRowRemoved(evt: any): void {
		

		const selection: Selection = <Selection>evt.data;

		this.data.selections.forEach(
			(item) => {
				if (item.selectionId === selection.selectionId) {
					item.isDeleted = true;
					item.orderBy = -1;

				

					return;
				}
			}
		);

		this.data.selections.filter(item => !item.isDeleted).forEach((selection, index) => selection.orderBy = index);

		
	}

	public onRowUpdated(evt: any): void {
		

		const selection: Selection = <Selection>evt.data;

		const selectionElement: SelectionElement = this.data.elements.find((element) => element.listElementId === selection.listElementId);

		let selectionIndex: number = this.data.selections.findIndex((dataSelection) => dataSelection.selectionId === selection.selectionId);

		if (selectionElement) {
			selection.caption = selectionElement.caption;
			selection.selectionName = selectionElement.listElement;
		}

		this.data.selections[selectionIndex] = Object.assign(this.data.selections[selectionIndex], selection);

		
	}

	public getOrderColumn(evt: any, selectionId) {
		let dataIndex = evt.component.option('dataSource');
		let index = dataIndex.findIndex(x => x.selectionId == selectionId);
		return (index!=undefined && index!=null && index>-1 ? index + 1 : 0);
	}

	public onSaved(evt: any): void {
		

		const selectionsToSave: SelectionOutput[] = this.data.selections
			.map(
				selection => new SelectionOutput(
					selection.selectionId,
					this.selectionSet.selectionSetId,
					this.selectionElements.length > 0 ? selection.listElementId : 0,
					selection.selectionName,
					selection.isVisible,
					selection.colWidth,
					selection.dataType,
					selection.dataTypeFormat,
					this.getOrderColumn(evt, selection.selectionId),
					selection.htmlControlType,
					selection.searchType,
					selection.isDeleted,
					selection.selectionMode ? selection.selectionMode : "multiple",
					selection.aggregateFunctionId,
					selection.instantSelectionApplication
				)
			);



		this._settingsService.saveSelections(
			this.selectionSet.selectionSetId,
			selectionsToSave,
			{
				name: "saveSelections",
				showLoadingIndicator: true,
				responseLoggingEnabled: false,
			}
		).subscribe(
			{
				next: (response) => {
					

					this.initialize();

					this.allowReordering = true;
					this._editingProcessActive = false;
				}
			}
		);
	}

	public allowEditing(evt: any): boolean {
		

		return !evt.row.data.isMandatory;
	}

	public allowUpdating(evt: any): boolean {
		return true;
	}

	public allowDeleting(evt: any): boolean {
		return !evt.row.data.isMandatory;
	}

	public onEditorPreparing(evt: any): void {
		

		if (evt.parentType === "dataRow") {
			const selection: Selection = <Selection>evt.row.data;

			if (evt.dataField !== "isVisible") { // Utils.nameof(selection, (x) => x.isVisible)) {
				evt.editorOptions.disabled = selection.isMandatory;
				evt.editorOptions.focusStateEnabled = !selection.isMandatory;
				evt.editorOptions.hoverStateEnabled = !selection.isMandatory;
				evt.editorOptions.readOnly = selection.isMandatory;
			}
		}
	}

	public onInitNewRow(evt: any): void {
		

		const component: DxDataGrid = evt.component;

		this.allowReordering = false;

		evt.data.orderBy = component.getVisibleRows().length;
		evt.data.aggregateFunctionId = null;
		evt.data.selectionMode = "multiple";
		evt.data.isVisible = true;

		//? This does sort the visible rows but the grid is not refreshing itself to reflect the changes.
	
	}

	private _editingProcessActive: boolean;

	private _reoderingCache: { selectionId: number, fromIndex: number }[] = [];

	public onEditingStart(evt: any): void {
		

		if (!this._editingProcessActive) {
			for (let a = 0; a < this.data.selections.length; a++) {
				const selection = this.data.selections[a];

				this._reoderingCache.push(
					{
						selectionId: selection.selectionId,
						fromIndex: selection.orderBy
					}
				);
			}

			this._editingProcessActive = true;
		}
	}

	public onEditCanceled(evt: any): void {
		

		this.allowReordering = true;

		for (let a = 0; a < evt.changes.length; a++) {
			const change = evt.changes[a];

			const reoderingCacheItem = this._reoderingCache.find((item) => item.selectionId === change.key.selectionId);

			if (reoderingCacheItem) {
				this.data.selections.splice(change.data.orderBy, 1);
				this.data.selections.splice(reoderingCacheItem.fromIndex, 0, change.key);

				this.data.selections.forEach((selection, index) => selection.orderBy = index);
			}
		}

		

		this.prepareSelections();

		this._reoderingCache = [];

		this._editingProcessActive = false;
	}

	constructor(
		private _settingsService: SettingsService,
	) {
		this.onReorder = this.onReorder.bind(this);
	}

	ngOnInit(): void {
		this.initialize();
	}
}
